import { CommonModule }         from '@angular/common';
import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainResolver }         from 'src/app/components/main/shared/main.resolver';
import { SelfCareComponent }    from './self-care.component';
import { SelfCareGuard }        from './self-care.guard';

export const routes: Routes = [
  {
    path:                  '',
    component:             SelfCareComponent,
    data:                  {},
    canActivate:           [SelfCareGuard],
    resolve:               { datas: MainResolver },
    runGuardsAndResolvers: 'always',
  },
];

@NgModule ({
             declarations: [],
             imports:      [
               RouterModule.forChild (routes),
               CommonModule,
             ],
             exports:      [RouterModule],
           })
export class SelfCareRouting {
}
